/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Liebigschule_Giessen2Inputs */

const en__field_enum_liebigschule_giessen2 = /** @type {(inputs: _Field_Enum_Liebigschule_Giessen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liebigschule (Gießen)`)
};

const de__field_enum_liebigschule_giessen2 = /** @type {(inputs: _Field_Enum_Liebigschule_Giessen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liebigschule (Gießen)`)
};

/**
* | output |
* | --- |
* | "Liebigschule (Gießen)" |
*
* @param {_Field_Enum_Liebigschule_Giessen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_liebigschule_giessen2 = /** @type {((inputs?: _Field_Enum_Liebigschule_Giessen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Liebigschule_Giessen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_liebigschule_giessen2(inputs)
	return de__field_enum_liebigschule_giessen2(inputs)
});
export { _field_enum_liebigschule_giessen2 as "_field_enum_Liebigschule_Giessen" }